import RestApiModel from "@/api/Model/RestApiModel";
import { fisgApi } from '@/api';

class HeaderInfo extends RestApiModel {
  static getResourceEndpoint() {
    return '/GetHeaderInformation';
  }

  static list() {
    return fisgApi.get('/GetHeaderInformation', { params: { applicationExternalKey : process.env.VUE_APP_AUTH0_CLIENT_ID } });
  }
}

export default HeaderInfo;
